import { useEffect, useState } from "react";
import type { ShopView } from "@frontier/content/shop";

export function shopServerTime(
  serverNow: number,
  receivedAt: number,
  monotonicNow: number,
): number {
  return serverNow + Math.max(0, monotonicNow - receivedAt);
}

export function shopCountdown(endsAt: number, serverNow: number): string {
  const seconds = Math.max(0, Math.ceil((endsAt - serverNow) / 1000));
  return [
    Math.floor(seconds / 3600),
    Math.floor(seconds / 60) % 60,
    seconds % 60,
  ]
    .map((value) => String(value).padStart(2, "0"))
    .join(":");
}

export function useShopClock(
  view: ShopView | null,
  receivedAt: number | null,
  onExpire: () => Promise<void>,
): number | null {
  const [now, setNow] = useState(() => performance.now());
  useEffect(() => {
    if (
      !view ||
      receivedAt === null ||
      !view.items.some(
        (item) => item.endsAt !== null || item.startsAt > view.serverNow,
      )
    )
      return;
    setNow(performance.now());
    const timer = window.setInterval(() => setNow(performance.now()), 1000);
    return () => window.clearInterval(timer);
  }, [view, receivedAt]);
  const time =
    view && receivedAt !== null
      ? shopServerTime(view.serverNow, receivedAt, now)
      : null;
  const expired =
    time !== null &&
    view !== null &&
    view.items.some((item) => item.endsAt !== null && item.endsAt <= time);
  useEffect(() => {
    if (expired) void onExpire();
  }, [expired, view, receivedAt, onExpire]);
  return time;
}
